function renderInline(text) {
  const tokens = [];
  const regex = /(\*\*[^*]+\*\*|\*[^*\n]+\*|\[[^\]]+\]\((?:https?:|mailto:)[^)]+\))/g;
  let last = 0;
  let key = 0;
  let m;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) tokens.push(text.slice(last, m.index));
    const tok = m[0];
    if (tok.startsWith("**")) {
      tokens.push(<strong key={key++} className="font-medium text-ink">{tok.slice(2, -2)}</strong>);
    } else if (tok.startsWith("[")) {
      const label = tok.slice(1, tok.indexOf("]"));
      const url = tok.slice(tok.indexOf("](") + 2, -1);
      tokens.push(
        <a key={key++} href={url} target="_blank" rel="noopener noreferrer" className="text-ink underline decoration-line underline-offset-4 hover:text-ember transition-colors duration-300">
          {label}
        </a>
      );
    } else {
      tokens.push(<em key={key++} className="font-serif italic text-ink/90">{tok.slice(1, -1)}</em>);
    }
    last = m.index + tok.length;
  }
  if (last < text.length) tokens.push(text.slice(last));
  return tokens;
}

export function RichText({ text }) {
  const blocks = (text || "").split(/\n\s*\n/).filter(Boolean);
  return (
    <div className="space-y-6">
      {blocks.map((b, i) => {
        if (b.startsWith("### "))
          return <h4 key={i} className="font-serif text-xl md:text-2xl text-ink mt-10">{renderInline(b.slice(4))}</h4>;
        if (b.startsWith("## "))
          return <h3 key={i} className="font-serif text-2xl md:text-3xl text-ink mt-10">{renderInline(b.slice(3))}</h3>;
        if (b.startsWith("> "))
          return (
            <blockquote key={i} className="border-l-2 border-ember pl-6 py-1 font-serif italic text-xl md:text-2xl text-ink/80 leading-relaxed">
              {renderInline(b.slice(2))}
            </blockquote>
          );
        return (
          <p key={i} className="text-base md:text-lg text-fog leading-relaxed font-light">
            {renderInline(b)}
          </p>
        );
      })}
    </div>
  );
}
